import { render, staticRenderFns } from "./tutor.vue?vue&type=template&id=53e3a6d0&scoped=true&"
import script from "./tutor.vue?vue&type=script&lang=js&"
export * from "./tutor.vue?vue&type=script&lang=js&"
import style0 from "./tutor.vue?vue&type=style&index=0&id=53e3a6d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e3a6d0",
  null
  
)

export default component.exports